import { useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "../../lib/api";
import { Button } from "../ui/button";
import { PencilSimple } from "@phosphor-icons/react";
import { FocusInstructions } from "./FocusInstructions";

// Review-header card: view / edit the Focus direction; applies to the next Generate.
export const FocusCard = ({ review, readOnly, onSaved }) => {
  const focus = review.focus || {};
  const [edit, setEdit] = useState(false);
  const [text, setText] = useState(focus.instructions || "");
  const [saving, setSaving] = useState(false);

  const save = async () => {
    setSaving(true);
    try {
      const { data } = await api.put(`/rapid-reviews/${review.id}/focus`, {
        term: focus.term || "", functions: focus.functions || [], instructions: text,
      });
      onSaved(data.focus);
      setEdit(false);
      toast.success("Focus saved — applies to the next Generate");
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setSaving(false); }
  };

  if (!edit && !focus.instructions && readOnly) return null;
  return (
    <div className="border border-amber-300/70 bg-amber-50/40 px-3 py-2 text-xs" data-testid="rr-focus-card">
      {!edit ? (
        <div className="flex items-start gap-2">
          <div className="flex-1 whitespace-pre-wrap" data-testid="rr-focus-instructions-text">
            <b>Focus instructions: </b>
            {focus.instructions || <span className="text-muted-foreground">None — add direction to steer the AI questions.</span>}
          </div>
          {!readOnly && (
            <button type="button" data-testid="rr-focus-edit-btn" onClick={() => { setText(focus.instructions || ""); setEdit(true); }}
              className="flex items-center gap-1 underline text-muted-foreground hover:text-foreground shrink-0">
              <PencilSimple size={12} /> Edit
            </button>
          )}
        </div>
      ) : (
        <div className="space-y-2">
          <FocusInstructions value={text} onChange={setText} standardIds={review.standard_ids || [review.standard_id]}
            functions={focus.functions} term={focus.term} />
          <div className="flex justify-end gap-1.5">
            <Button size="sm" variant="outline" className="rounded-none h-7" onClick={() => setEdit(false)}>Cancel</Button>
            <Button size="sm" data-testid="rr-focus-save-btn" className="rounded-none h-7" disabled={saving} onClick={save}>
              {saving ? "Saving…" : "Save focus"}
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};
